import { SVGProps } from 'react';

const ArrowUpToLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 3h14M6 13l6-6 6 6m-6-6v14"
    />
  </svg>
);
export default ArrowUpToLine;
